import { render, staticRenderFns } from "./start.vue?vue&type=template&id=2c1f4adb&scoped=true"
import script from "./start.vue?vue&type=script&lang=js"
export * from "./start.vue?vue&type=script&lang=js"
import style0 from "./start.vue?vue&type=style&index=0&id=2c1f4adb&prod&lang=css"
import style1 from "./start.vue?vue&type=style&index=1&id=2c1f4adb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f4adb",
  null
  
)

export default component.exports